// 注册滚动条加载触发事件v-loadCascader绑定
export default {
  inserted: function inserted(el, binding) {
    var cascaderDom = el.querySelector('.el-cascader__dropdown .el-cascader-menu__wrap' // 滚动条所在元素
    );
    if (cascaderDom) {
      cascaderDom.addEventListener('scroll', function () {
        var _this = this;
        var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (condition) {
          var temp = this.scrollTop;
          binding.value();
          setTimeout(function () {
            _this.scrollTop = temp + 100; // 滚动加载更多时，显示的数据在上次位置基础上往上滑动100
          }, 0);
        }
      });
    }
  }
};